<template>
  <div id="sidebarContainer" v-if="isLoggedIn" v-bind:class="{ collapsed: collapsed }">
    <div id="appSidebar" @mouseover="mouseOver" @mouseleave="mouseOut">
      <div class="sidebarSection sidebarLogoSection">
        <FFLogo :markOnly="collapsed" @click='goHome()'/>
      </div>
      <div class="sidebarSection sidebarClientSelect" v-if="multipleClients && !collapsed">
        <select @change="changeSelectedClient($event)">
          <option v-for="(value, key) in availableClients" :key="key" :value="key" :selected="key == selectedClient">{{value.name}}</option>
        </select>
      </div>
      <div v-if="!collapsed" class="sidebarSection sidebarButtons">
        <div class="sidebarButtonWrapper">
          <SidebarButton v-for="link in visibleLinks" :key="link.name" :link="link"/>
        </div>
      </div>
      <div v-if="!collapsed" @click='logout()' class="sidebarSection sidebarLogout">
        Logout
      </div>
    </div>

  </div>
</template>

<script>
import SidebarButton from '../components/SidebarButton.vue'
import FFLogo from '../components/FFLogo.vue'
import firebase from 'firebase/app';
require('firebase/auth')

export default {
  name: 'Sidebar',
  components: {
    SidebarButton,
    FFLogo
  },
  data () {
    return {
      linkData: [
        {
          "name": "Videos",
          "admin": false,
          "routeName": "videos"
        },
        {
          "name": "Delivery Batches",
          "admin": true,
          "routeName": "batches"
        },
        {
          "name": "Creative Directions",
          "admin": true,
          "routeName": "creative directions"
        },
        {
          "name": "Facebook Ads",
          "admin": true,
          "routeName": "ads"
        },
        {
          "name": "Admin Settings",
          "admin": true,
          "routeName": "admin"
        }
      ],
      "collapsed": true,
      "hover": false
    }
  },
  methods: {
    mouseOver: function(){
      this.hover = true;
      setTimeout(() => {
        if (this.hover && this.collapsed) {
          this.collapsed = false
        }
      }, 400);
    },
    mouseOut: function(){
      this.hover = false;
      setTimeout(() => {
        if (!this.hover && !this.collapsed) {
          this.collapsed = true
        }
      }, 400);
    },
    logout: function(){
      firebase.auth().signOut().then( () => {
        this.$store.dispatch("logoutReset")
        this.$router.replace('/login')
      })
    },
    routeSelected: function(routeName) {
      if (routeName === this.$route.name) {
        return true
      } else {
        return false
      }

    },
    settings: function(){
      this.$router.replace('/admin')
    },
    goHome: function(){
      this.$router.push('/')
    },
    changeSelectedClient: function(event){
      var newRoute = {}
      if (this.$route.params.id && this.$route.name) {
        newRoute.name = this.$route.name,
        newRoute.params = {id: event.target.value}
      } else {
        newRoute.name = "video grid",
        newRoute.params = {id: event.target.value}
      }
      this.$router.push(newRoute)
    }
  },
  computed: {
    visibleLinks() {
      var visibleLinks = []
      this.linkData.forEach((link)=>{
        if (!link.admin || this.$store.getters.isAdmin) {
          visibleLinks.push({
            ...link,
            selected: (link.routeName === this.$route.name)
          })
        }
      })
      return visibleLinks
    },
    availableClients () {
      return this.$store.state.clientCollection;
    },
    selectedClient () {
      return this.$store.state.selectedClient;
    },
    multipleClients (){
      if (Object.keys(this.$store.state.clientCollection).length > 1) {
        return true
      } else {
        return false
      }
    },
    isLoggedIn() {
      if (this.$store.state.currentUser) {
        return true
      } else {
        return false
      }
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    }
  },
  watch:{
    $route (){
        if (!this.collapsed) {
          this.collapsed = true
        }
    }
}
}
</script>

<style lang="scss" scoped>
  #sidebarContainer {
    position: absolute;
    width: 100%;
    height: 100%;
    transition: .5s;
    &:not(.collapsed) {
      z-index: 100;
      background-color: rgba(0, 0, 0, 0.8);
      #appSidebar {
        width: 250px;
      }
      .sidebarLogoSection {
        height: 200px;
      }
    }
    &.collapsed {
      background-color: rgba(0, 0, 0, 0);
      #appSidebar {
        width: 60px;
      }
      .sidebarLogoSection {
        height: 150px;
      }
    }
  }
  .sidebarLogoSection {
    svg {
      width: 150px;
    }
  }
  #appSidebar {
    box-shadow: 0px 0px 5px rgba(0, 0, 0, .8);
    position: absolute;
    z-index: 20;
    color: #FFFFFF90;
    height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #333746;
    .sidebarSection {
      display: flex;
      flex-direction: column;
    }
    .sidebarLogoSection {
      justify-content: center;
      align-items: center;
    }
    .sidebarClientSelect {
      justify-content: center;
      align-items: center;
      height: 120px;
    }
    .sidebarButtons {
      flex: 1;
      border-top: 2px solid #2E303A;
      align-items: flex-start;
      flex-direction: row;
      .sidebarButtonWrapper {
        width: 100%;
      }
      .sidebarButton {
        height: 55px;
        border-bottom: 2px solid #2E303A;
        display: flex;
        align-items: center;
        padding-left: 25px;
        &.selected {
          background-color: #73A9F720;
        }
      }
    }

    .sidebarLogout {
      height: 60px;
      padding-left: 25px;
      border-top: 2px solid #2E303A;
      justify-content: center;
    }
  }
</style>
